<script setup lang="ts">

const { t } = useEkI18n();
const settingsStore = useSettingsStore();

const options = [
  MapSetting.google, 
  MapSetting.apple
];

async function updateDefaultMap(defaultMap: MapSetting) {
  await settingsStore.set('defaultMap', defaultMap);
}
</script>

<template>
  <SettingsSelect 
    :options="options"
    :label="t('settings.general.map')"
    :description="t('settings.general.defaultMapDescription')"
    :placeholder="settingsStore.settings.defaultMap"
    :value="settingsStore.settings.defaultMap"
    :resolve-key="(o: MapSetting)=>o"
    @change="updateDefaultMap"
  >
    <template #option="{option}">
      {{ t("settings.general.mapOptions." + option) }}
    </template>
  </SettingsSelect>
</template>

<style scoped>
</style>
